import styled from '@emotion/styled';
import { Button, Divider, Table } from 'antd';
import { useEffect, useState } from 'react';
import { YELLOW } from '../../../shared/colors';

const Container = styled.div`
  th {
    background-color: ${YELLOW} !important;
    color: white !important;
    font-weight: bold; 
  }

  .style-row {
    font-family: Poppins-L;
    color: black;

    &:hover > td {
      background-color: #eee !important;
      cursor: pointer;
    }
  }

  > .picker {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    margin-bottom: 25px;
  }

  .form-control-lg {
    min-height: 36px;
    min-width: 240px;
    padding: 6px 10px;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 20px;
    }

    > .picker {
      align-items: stretch;
      flex-direction: column;
    }

    .form-control-lg {
      min-width: 0;
      width: 100%;
    }
  }
`;

export const Courbes = () => {
  const [reglements, setReglements] = useState<any[]>([]);
  const [filterReglements, setFilterReglements] = useState<any[]>([]);
  const [selectData, setSelectData] = useState('');

  useEffect(() => {
    setReglements(REGLEMENTS);
    setFilterReglements(REGLEMENTS);
  }, []);

  const filter = () => {
    
    if (selectData) {
      setFilterReglements(
        reglements.filter((ac) => {
          console.log(selectData, reglements, ac.titre.includes(selectData));
          if (ac.titre.includes(selectData) > -1) {
            return true;
          }
          return false;
        }),
      );
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectData(value);
  };
  const COLUMNS = [
    {
      title: 'Titre du document',
      dataIndex: 'title',
      render: (cell: any, row: any) => (
        <span onClick={() => window.open(row.lien, '_blank')}>{cell}</span>
      ),
      width: 1300,
    },
    {
      title: 'Taille',
      dataIndex: 'taille',
      width: 200,
    },
    {
      title: 'Pays',
      dataIndex: 'pays',
      width: 200,
    },
    {
      title: 'Année',
      dataIndex: 'annee',
      width: 200,
    },
    
  ];

  return (
    <Container>
      <h2>COURBES DE TAUX PAR PAYS</h2>
      <Divider style={{ backgroundColor: 'orange', marginBottom: 10 }} />
      <div className='picker'>
      <input
              className="form-control-lg"
              placeholder="Rechercher"
              type="text"
              onChange={handleInput}
            />
        <Button className='butt' onClick={filter}>
          Valider
        </Button>
      </div>

      <div></div>
      <Table
        columns={COLUMNS}
        dataSource={filterReglements}
        rowClassName={(row, index) => 'style-row'}
        scroll={{ x: 900 }}
        size='small'
        style={{ zoom: 1 }}
        // pagination={false}
      />
    </Container>
  );
};


const REGLEMENTS = [
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Gabon-septembre-2023.pdf", title:"Courbes de rendement des titres publics du Gabon - septembre 2023",
    taille: "226 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Congo-septembre-2023.pdf", title:"Courbes de rendement des titres publics du Congo - septembre 2023",
    taille: "230 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Cmr-septembre-2023.pdf", title:"Courbes de rendement des titres publics du Cameroun - septembre 2023",
    taille: "223 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/08/Courbe-Gabon_juil-2023.pdf", title:"Courbe de rendements des titres publics du Gabon - juillet 2023",
    taille: "525 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/08/Courbe-Congo_juil-2023.pdf", title:"Courbe de rendements des titres publics du Congo - juillet 2023",
    taille: "551 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/08/Courbe-CMR_juil-2023.pdf", title:"Courbe de rendements des titres publics du Cameroun - juillet 2023",
    taille: "534 KB",
    pays: " Cameroun",
    annee: " 2023",
  },

  {
    lien: "https://www.beac.int/wp-content/uploads/2023/07/Courbe-gabon_juin-2023.pdf", title:"Courbe de rendements des titres publics gabonais - juin 2023",
    taille: "557 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/07/Courbe-Congo_juin-2023.pdf", title:"Courbe de rendements des titres publics congolais - juin 2023",
    taille: "555 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/07/Courbe-CMR_juin-2023.pdf", title:"Courbe de rendements des titres publics camerounais - juin 2023",
    taille: "572 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/06/Courbe-Gabon_mai-2023.pdf", title:"Courbe de rendements des titres publics gabonais - mai 2023",
    taille: "728 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/06/Courbe-Congo_mai-2023.pdf", title:"Courbe de rendements des titres publics congolais - mai 2023",
    taille: "688 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/06/Courbe-CMR_mai-2023.pdf", title:"Courbe de rendements des titres publics camerounais - mai 2023",
    taille: "688 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/05/Courbe-Gabon_avril-2023.pdf", title:"Courbe de rendements des titres publics gabonais - avril 2023",
    taille: "487 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/05/Courbe-Congo_avril-2023.pdf", title:"Courbe de rendements des titres publics congolais - avril 2023",
    taille: "497 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/05/Courbe-CMR_avril-2023.pdf", title:"Courbe de rendements des titres publics camerounais - avril 2023",
    taille: "514 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/04/Courbe-Gab-mars-2023.pdf", title:"Courbe de rendements des titres publics gabonais - mars 2023",
    taille: "469 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/04/Courbe-CG-mars-2023.pdf", title:"Courbe de rendements des titres publics congolais - mars 2023",
    taille: "474 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/04/Courbe-CMR-mars-2023.pdf", title:"Courbe de rendements des titres publics camerounais - mars 2023",
    taille: "455 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/02/Courbe-Gabon-janv-2023.pdf", title:"Courbe de rendements des titres publics gabonais - janvier 2023",
    taille: "673 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/02/Courbe-Cong-janv-2023.pdf", title:"Courbe de rendements des titres publics congolais - janvier 2023",
    taille: "660 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/02/Courbe-CMR-janv-2023.pdf", title:"Courbe de rendements des titres publics camerounais - janvier 2023",
    taille: "642 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-Gabon_déc-2022.pdf", title:"Courbe de rendements des titres publics gabonais - décembre 2022",
    taille: "465 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-Congo-déc-2022.pdf", title:"Courbe de rendements des titres publics congolais - décembre 2022",
    taille: "480 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-CMR_déc-2022.pdf", title:"Courbe de rendements des titres publics camerounais - décembre 2022",
    taille: "459 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-Gabon_nov-2022.pdf", title:"Courbe de rendements des titres publics gabonais - novembre 2022",
    taille: "616 KB",
    pays: " Gabon",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-Congo_nov-2022.pdf", title:"Courbe de rendements des titres publics congolais - novembre 2022",
    taille: "686 KB",
    pays: " Congo",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-CMR_nov-2022.pdf", title:"Courbe de rendements des titres publics camerounais - novembre 2022",
    taille: "644 KB",
    pays: " Cameroun",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/11/Courbe-Gabon-oct-2022.pdf", title:"Courbe de rendements des titres publics gabonais - octobre 2022",
    taille: "461 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/11/Courbe-CG-oct-2022.pdf", title:"Courbe de rendements des titres publics congolais - octobre 2022",
    taille: "468 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/11/Courbe-CMR-oct-2022.pdf", title:"Courbe de rendements des titres publics camerounais - octobre 2022",
    taille: "476 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-Gabon-sept-2022.pdf", title:"Courbe de rendements des titres publics gabonais - septembre 2022",
    taille: "614 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-CG-sept-2022.pdf", title:"Courbe de rendements des titres publics congolais - septembre 2022",
    taille: "594 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/01/Courbe-CMR-sept-2022.pdf", title:"Courbe de rendements des titres publics camerounais - septembre 2022",
    taille: "593 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/09/Courbe-Gabon_août-2022.pdf", title:"Courbe de rendements des titres publics gabonais - août 2022",
    taille: "406 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/09/Courbe-Congo_août-2022.pdf", title:"Courbe de rendements des titres publics congolais - août 2022",
    taille: "416 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/09/Courbe-CMR_août-2022.pdf", title:"Courbe de rendements des titres publics camerounais - août 2022",
    taille: "394 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/07/Courbe-Gabon_juin-2022.pdf", title:"Courbe de rendements des titres publics gabonais - juin 2022",
    taille: "420 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/07/Courbe-Congo_juin-2022.pdf", title:"Courbe de rendements des titres publics congolais - juin 2022",
    taille: "414 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/07/Courbe-CMR_juin-2022.pdf", title:"Courbe de rendements des titres publics camerounais - juin 2022",
    taille: "385 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/06/Courbe-Gabon_mai-2022.pdf", title:"Courbe de rendements des titres publics gabonais - mai 2022",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/06/Courbe-Congo_mai-2022.pdf", title:"Courbe de rendements des titres publics congolais - mai 2022",
    taille: "1 MB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/05/Courbe-Gabon_avril-2022.pdf", title:"Courbe de rendements des titres publics gabonais - avril 2022",
    taille: "832 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/05/Courbe-Congo_avril-2022.pdf", title:"Courbe de rendements des titres publics congolais - avril 2022",
    taille: "783 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/05/Courbe-CMR_avril-2022.pdf", title:"Courbe de rendements des titres publics camerounais - mars 2022",
    taille: "777 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/03/Courbe-Gabon_fév-2022.pdf", title:"Courbe de rendements des valeurs du Trésor public Gabonais - février 2022",
    taille: "977 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/03/Courbe-Congo_fév-2022.pdf", title:"Courbe de rendements des valeurs du Trésor public Congolais - février 2022",
    taille: "949 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/03/Courbe-CMR_fév-2022.pdf", title:"Courbe de rendements des valeurs du Trésor public Camerounais - février 2022",
    taille: "934 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/02/Courbe-GA_janv-2022.pdf", title:"Courbe de rendements des valeurs du Trésor public gabonais - janvier 2022",
    taille: "800 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/02/Courbe-CG_janv-2022.pdf", title:"Courbe de rendements des valeurs du Trésor public congolais - janvier 2022",
    taille: "772 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/02/Courbe-CMR_Janv-2022.pdf", title:"Courbe de rendements des valeurs du Trésor public camerounais - janvier 2022",
    taille: "795 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/01/Courbe-GAB_déc-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public gabonais - décembre 2021",
    taille: "800 KB",
    pays: " Gabon",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/01/Courbe-CG_déc-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public congolais - décembre 2021",
    taille: "791 KB",
    pays: " Congo",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2022/01/Courbe-CMR_déc-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public camerounais - décembre 2021",
    taille: "779 KB",
    pays: " Cameroun",
    annee: " 2022",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/12/Courbe-GAB_nov-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public gabonais - novembre 2021",
    taille: "617 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/12/Courbes-CONGO_nov-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public congolais - novembre 2021",
    taille: "563 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/12/Courbes-CMR_nov-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public Camerounais - novembre 2021",
    taille: "569 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/11/Courbe-GAB_oct-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public gabonais - octobre 2021",
    taille: "829 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/11/Courbe-CONG_oct-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public congolais - octobre 2021",
    taille: "848 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/11/Courbe-CMR_oct-2021.pdf", title:"Courbe de rendements des valeurs du Trésor public camerounais - octobre 2021",
    taille: "818 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/10/Courbe-Gabon_sept-2021.pdf", title:"Courbe de rendements des valeurs du Trésor gabonais - septembre 2021",
    taille: "863 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/10/Courbe-CONG_sept-2021.pdf", title:"Courbe de rendements des valeurs du Trésor congolais - septembre 2021",
    taille: "833 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/10/Courbe-CAM_sept-2021.pdf", title:"Courbe de rendements des valeurs du Trésor camerounais - septembre 2021",
    taille: "843 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/10/Courbe-Gabon_Août-2021.pdf", title:"Courbe de rendements des valeurs du Trésor gabonais - août 2021",
    taille: "846 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/10/Courbe-CONG_Août-2021.pdf", title:"Courbe de rendements des valeurs du Trésor congolais - août 2021",
    taille: "883 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/10/Courbe-CAM_Août-2021.pdf", title:"Courbe de rendements des valeurs du Trésor camerounais - août 2021",
    taille: "879 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/08/Courbe-Gabon_juil-2021.pdf", title:"Courbe de rendements des valeurs du Trésor gabonais - juillet 2021",
    taille: "517 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/08/Courbe-Congo_juil-2021.pdf", title:"Courbe de rendements des valeurs du Trésor congolais - juillet 2021",
    taille: "491 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/08/Courbe-Cam_juil-2021.pdf", title:"Courbe de rendements des valeurs du Trésor camerounais - juillet 2021",
    taille: "491 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/07/Courbe-Gabon_juin-2021.pdf", title:"Courbe de rendements des valeurs du Trésor gabonais - juin 2021",
    taille: "561 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/07/Courbe-Congo_juin-2021.pdf", title:"Courbe de rendements des valeurs du Trésor congolais - juin 2021",
    taille: "570 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/07/Courbe-Cam_juin-2021.pdf", title:"Courbe de rendements des valeurs du Trésor camerounais - juin 2021",
    taille: "532 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/07/Courbe-Gabon_mai-2021.pdf", title:"Courbe de rendements des valeurs du Trésor gabonais - mai 2021",
    taille: "522 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/07/Courbe-Congo_mai-2021.pdf", title:"Courbe de rendements des valeurs du Trésor congolais - mai 2021",
    taille: "531 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/07/Courbe-Cam_mai-2021.pdf", title:"Courbe de rendements des valeurs du Trésor camerounais - mai 2021",
    taille: "516 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/06/Courbe-Gabon_Avril-2021.pdf", title:"Courbe de rendements des valeurs du Trésor gabonais - avril 2021",
    taille: "550 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/06/Courbe-Congo_Avril-2021.pdf", title:"Courbe de rendements des valeurs du Trésor congolais - avril 2021",
    taille: "520 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/06/Courbe-CMR_Avril-2021.pdf", title:"Courbe de rendements des valeurs du Trésor camerounais - avril 2021",
    taille: "521 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/04/Courbe-Gabon_fév-2021.pdf", title:"Courbe de rendements des titres publics gabonais - février 2021",
    taille: "504 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/04/Courbe-Congo_fév-2021.pdf", title:"Courbe de rendements des titres publics congolais - février 2021",
    taille: "500 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/04/Courbe-Cmr_fév-2021.pdf", title:"Courbe de rendements des titres publics camerounais - février 2021",
    taille: "497 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/02/Courbe-Gabon_janv-2021.pdf", title:"Courbe de rendements des titres publics gabonais - janvier 2021",
    taille: "480 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/02/Courbe-Congo_janv-2021.pdf", title:"Courbe de rendements des titres publics congolais - janvier 2021",
    taille: "455 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/02/Courbe-CMR_janv-2021-1.pdf", title:"Courbe de rendements des titres publics camerounais - janvier 2021",
    taille: "443 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/02/CBT-Gabon_déc-2020.pdf", title:"Courbe de rendements des titres publics gabonais - décembre 2020",
    taille: "452 KB",
    pays: " Gabon",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/02/CBT-Congo_déc-2020.pdf", title:"Courbe de rendements des titres publics congolais - décembre 2020",
    taille: "458 KB",
    pays: " Congo",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2021/02/CBT-Cam_déc-2020.pdf", title:"Courbe de rendements des titres publics camerounais - décembre 2020",
    taille: "434 KB",
    pays: " Cameroun",
    annee: " 2021",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-taux-de-rendement-du-Gabon-Sept-2020.pdf", title:"Courbe de rendements des titres publics gabonais - septembre 2020",
    taille: "502 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-taux-de-rendement-du-Gabon-Aout-20.pdf", title:"Courbe de rendements des titres publics gabonais - août 2020",
    taille: "500 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-taux-de-rendement-du-Congo-sept-2020.pdf", title:"Courbe de rendements des titres publics congolais - septembre 2020",
    taille: "501 KB",
    pays: " Congo",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-taux-de-rendement-du-Congo-Aout-20.pdf", title:"Courbe de rendements des titres publics congolais - août 2020",
    taille: "486 KB",
    pays: " Congo",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-taux-de-rendement-du-Cameroun-sept-2020.pdf", title:"Courbe de rendements des titres publics camerounais - septembre 2020",
    taille: "513 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-taux-de-rendement-du-Cameroun-Aout-20_1.pdf", title:"Courbe de rendements des titres publics camerounais - août 2020",
    taille: "485 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Gabon-Juillet-2020.pdf", title:"Courbe de rendements des titres publics gabonais - juillet 2020",
    taille: "392 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Congo-Juillet_2020.pdf", title:"Courbe de rendements des titres publics congolais - juillet 2020",
    taille: "391 KB",
    pays: " Congo",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Cameroun-Juillet-2020.pdf", title:"Courbe de rendements des titres publics camerounais - juillet 2020",
    taille: "391 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Gabon-Juin-2020.pdf", title:"Courbe de rendements des titres publics gabonais - juin 2020",
    taille: "261 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Congo-Juin-2020.pdf", title:"Courbe de rendements des titres publics congolais - juin 2020",
    taille: "392 KB",
    pays: " Congo",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Cameroun-Juin-2020.pdf", title:"Courbe de rendements des titres publics camerounais - juin 2020",
    taille: "255 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe-Gabon-Mai-2020.pdf", title:"Courbe de rendements des titres publics gabonais - mai 2020",
    taille: "255 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe_Congo-Mai-2020.pdf", title:"Courbe de rendements des titres publics congolais - mai 2020",
    taille: "391 KB",
    pays: " Congo",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe-Cameroun-Mai2020.pdf", title:"Courbe de rendements des titres publics camerounais - mai 2020",
    taille: "260 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe-Gabon-Avril-2020.pdf", title:"Courbe de rendements des titres publics gabonais - avril 2020",
    taille: "398 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbe-Congo-Avril-2020.pdf", title:"Courbe de rendements des titres publics congolais - avril 2020",
    taille: "418 KB",
    pays: " Congo",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/08/Courbes-Cameroun_Avril-2020.pdf", title:"Courbe de rendements des titres publics camerounais - avril 2020",
    taille: "368 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/03/Courbes-Cameroun_fév-2020.pdf", title:"Courbe de rendements des titres publics camerounais - février 2020",
    taille: "708 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/03/Courbes-Gabon_fév-2020.pdf", title:"Courbe de rendements des titres publics gabonais - février 2020",
    taille: "644 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/02/Courbe-Cam-janv-2020.pdf", title:"Courbe de rendements des titres publics camerounais - janvier 2020",
    taille: "597 KB",
    pays: " Cameroun",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/02/Courbe-Gabon-janv-2020.pdf", title:"Courbe de rendements des titres publics gabonais - janvier 2020",
    taille: "627 KB",
    pays: " Gabon",
    annee: " 2020",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/01/Courbes-Cam_déc-2019.pdf", title:"Courbe de rendements des titres publics camerounais - décembre 2019",
    taille: "746 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/01/Courbes-Gabon_déc-2019.pdf", title:"Courbe de rendements des titres publics gabonais - décembre 2019",
    taille: "767 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/01/Courbes-Cam_nov-2019.pdf", title:"Courbe de rendements des titres publics camerounais - novembre 2019",
    taille: "684 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2020/01/Courbes-Gabon_nov-2019.pdf", title:"Courbe de rendements des titres publics gabonais - novembre 2019",
    taille: "836 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/11/Courbes-de-rendement-Cam_oct-2019.pdf", title:"Courbe de rendements des titres publics camerounais - octobre 2019",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/11/Courbes-de-rendement-Gabon_oct-2019.pdf", title:"Courbe de rendements des titres publics gabonais - octobre 2019",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/10/Courbes-cam-sept-2019.pdf", title:"Courbe de rendements des titres publics camerounais - septembre 2019",
    taille: "321 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/10/Courbes-gab-sept-2019.pdf", title:"Courbe de rendements des titres publics gabonais - septembre 2019",
    taille: "321 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/10/Courbes-Cam-août-2019.pdf", title:"Courbe de rendements des titres publics camerounais - Août 2019",
    taille: "406 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/10/Courbes-Gabon-août-2019.pdf", title:"Courbe de rendements des titres publics gabonais - Août 2019",
    taille: "406 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/08/Cameroun-CBT-2019-NS01-07_2019.pdf", title:"Courbe des rendements des titres publics camerounais - juillet 2019",
    taille: "402 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/08/Gabon-CBT-2019-NS01-07_2019.pdf", title:"Courbe des rendements des titres publics gabonais - juillet 2019",
    taille: "403 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/08/Gabon-CBT-2019-NS01-06_2019.pdf", title:"Courbe des rendements des titres publics gabonais - juin 2019",
    taille: "403 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/08/Cameroun-CBT-2019-NS01-06_2019.pdf", title:"Courbe des rendements des titres publics camerounais - juin 2019",
    taille: "401 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/11/Courbes-Cameroun-mai-2019.pdf", title:"courbes de rendement des titres publics camerounais - mai 2019",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/11/Courbes-Gabon-avril-2019.pdf", title:"courbes de rendement des titres publics gabonais - avril 2019",
    taille: "2 MB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/11/Courbes-Gabon-mai-2019.pdf", title:"courbes de rendement des titres publics gabonais - mai 2019",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/11/Courbes-Cameroun-avril-2019.pdf", title:"courbes de rendement des titres publics camerounais - avril 2019",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/02/Gabon-CBT-03_2019.pdf", title:"Courbe des rendements des titres publics gabonais - mars 2019",
    taille: "838 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2019/02/Cameroun-CBT-03_2019.pdf", title:"Courbe des rendements des titres publics camerounais - mars 2019",
    taille: "837 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Gabon_Fév-2019.pdf", title:"Courbe des rendements des titres publics gabonais - février 2019",
    taille: "844 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-CMR_fév-2019.pdf", title:"Courbe des rendements des titres publics camerounais - février 2019",
    taille: "839 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Gabon_janv-2019.pdf", title:"Courbe des rendements des titres publics gabonais - janvier 2019",
    taille: "790 KB",
    pays: " Gabon",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Cameroun_janv-2019.pdf", title:"Courbe des rendements des titres publics camerounais - janvier 2019",
    taille: "789 KB",
    pays: " Cameroun",
    annee: " 2019",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Gabon-décembre-2018.pdf", title:"Courbe des rendements des titres publics gabonais - décembre 2018",
    taille: "598 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-CMR-décembre-2018-.pdf", title:"Courbe des rendements des titres publics camerounais - décembre 2018",
    taille: "596 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Gabon-novembre-2018.pdf", title:"Courbe des rendements des titres publics gabonais - novembre 2018",
    taille: "696 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Cmr_nov_2018.pdf", title:"Courbe des rendements des titres publics camerounais - novembre 2018",
    taille: "696 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-rendements-des-titres_-publics-camerounais-Oct-18.pdf", title:"Courbe des rendements des titres publics camerounais - octobre 2018",
    taille: "148 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-des-rendements-des-titres_-publics-gabonais-Oct-18.pdf", title:"Courbe des rendements des titres publics gabonais - octobre  2018",
    taille: "160 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes_CMR_sept_2018.pdf", title:"Courbe des taux de rendement des titres publics Camerounais - septembre 2018",
    taille: "790 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes_gabon_sept_2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - septembre 2018",
    taille: "786 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_GAB_08-2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - août 2018",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_CMR_08-2018.pdf", title:"Courbe des taux de rendement des titres publics Camerounais - août 2018",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_taux_rendement_CMR_07-2018.pdf", title:"Courbe des taux de rendement des titres publics Camerounais - juillet 2018",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_taux_rendement_Gabon_07-2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - juillet 2018",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Cameroun_juin_2018.pdf", title:"Courbe des taux de rendement des titres publics Camerounais - juin 2018",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Gabon_juin_2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - juin 2018",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Cam_mai_2018.pdf", title:"Courbe de rendement des titres publics Camerounais - mai 2018",
    taille: "259 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Gabon_mai_2018.pdf", title:"Courbe de rendement des titres publics Gabonais - mai 2018",
    taille: "257 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Cam_avril_2018.pdf", title:"Courbe de rendement des titres publics Camerounais - avril 2018",
    taille: "257 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Gabon_avril_2018.pdf", title:"Courbe de rendement des titres publics Gabonais - avril 2018",
    taille: "256 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Gabon_mars_2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - mars 2018",
    taille: "2 MB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Cameroun_mars_2018.pdf", title:"Courbe des taux de rendement des titres publics camerounais - mars 2018",
    taille: "2 MB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Gabon_février_2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - février 2018",
    taille: "2 MB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_Cameroun_février_2018.pdf", title:"Courbe des taux de rendement des titres publics camerounais - février 2018",
    taille: "2 MB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes_Gabon_janv_2018.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - Janvier 2018",
    taille: "954 KB",
    pays: " Gabon",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes_Cameroun_janv_2018.pdf", title:"Courbe des taux de rendement des titres publics camerounais - Janvier 2018",
    taille: "959 KB",
    pays: " Cameroun",
    annee: " 2018",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes_Gabon_déc_2017-1.pdf", title:"Courbe des taux de rendement des titres publics Gabonais - Décembre 2017",
    taille: "990 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes_Cameroun_déc_2017-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais - Décembre 2017",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/courbe_rendements_gab_oct17-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais - Octobre 2017",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2017",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT_Gabon_aout_2017-1.pdf", title:"Courbe des taux de rendement des titres publics Gabonais pour le mois d'août 2016",
    taille: "44 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT_Cameroun_aout_2017-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois d'août 2016",
    taille: "44 KB",
    pays: " Cameroun",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/taux_rendements_GABON-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais Juillet 2017",
    taille: "1 MB",
    pays: " Gabon",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/taux_rendements_CMR-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais Juillet 2017",
    taille: "1 MB",
    pays: " Cameroun",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-taux-rendement-Gabon-juin-2017-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon Juin 2017",
    taille: "42 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe-taux-rendement-Cameroun-juin-2017-1.pdf", title:"Courbe taux rendement Cameroun juin 2017",
    taille: "42 KB",
    pays: " Cameroun ",
    annee: " 2017",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Gabon_CBT_04_05_2017-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon avril et mai 2017",
    taille: "52 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Cameroun_CBT_04_05_2017-1.pdf", title:"Courbe Taux Rendement Titres Publics Cameroun avril et mai 2017",
    taille: "51 KB",
    pays: " Cameroun",
    annee: " 2017",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/GABON-CBT-Mars-2017-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon mars 2017",
    taille: "43 KB",
    pays: " Cameroun",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT-CAM-Mars-2017-1.pdf", title:"Courbe Taux Rendement Titres Publics Cameroun mars 2017",
    taille: "42 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT-CMR-février-2017_3-1.pdf", title:"Courbe Taux Rendement Titres Publics Cameroun février 2017",
    taille: "51 KB",
    pays: " Cameroun",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT-Gabon-TD-février-2017_2-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon février 2017",
    taille: "51 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT-Tchad-février-2017_1-1.pdf", title:"Courbe Taux Rendement Titres Publics Tchad février 2017",
    taille: "51 KB",
    pays: "Tchad",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Tchad_janvier_2017-3-1.pdf", title:"Courbe Taux Rendement Titres Publics Tchad janvier 2017",
    taille: "51 KB",
    pays: "Tchad",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Gabon_-janvier_2017-2-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon janvier 2017",
    taille: "51 KB",
    pays: " Gabon",
    annee: " 2017",
  },
  
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Cameroun_janvier_2017-1.pdf", title:"Courbe Taux Rendement Titres Publics Cameroun janvier 2017",
    taille: "51 KB",
    pays: " Cameroun",
    annee: " 2017",
  },

  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/resultat_BTA_Gabon_07122016-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de novembre 2016",
    taille: "463 KB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Calcule_courbe_novembre-_2016_Cameroun-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de novembre 2016",
    taille: "42 KB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Gabon_Calcule_courbe_octobre_2016-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon octobre 2016",
    taille: "42 KB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Gabon_Calcule_courbe_septembre_2016-1.pdf", title:"Courbe Taux Rendement Titres Publics Gabon Septembre 2016",
    taille: "43 KB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Cameroun_Calcule_courbe_octobre_2016-1.pdf", title:"Courbe Taux Rendement Titres Publics Cameroun octobre 2016",
    taille: "41 KB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Cameroun_Calcule_courbe_septembre_2016-2.pdf", title:"Courbe Taux Rendement Titres Publics Cameroun Septembre 2016",
    taille: "42 KB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Calcule-courbe_Gabon_Juin_2016-1-2.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de juin 2016",
    taille: "42 KB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Calcule_courbe_Tchad_juin_2016-2.pdf", title:"Courbe des taux de rendement des titres publics tchadiens pour le mois de juin 2016",
    taille: "42 KB",
    pays: "Tchad",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Calcule_courbe_Cameroun_Juin_2016-1-2.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de juin 2016",
    taille: "41 KB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CourbeTchad-2.pdf", title:"Courbe des taux de rendement des titres publics tchadiens pour le mois de mai 2016",
    taille: "2 MB",
    pays: "Tchad",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CourbeGabon-2.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de mai 2016",
    taille: "2 MB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CourbeCMR-2.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de mai 2016",
    taille: "2 MB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Gabon_courbe_Février_2016-1-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de février 2016",
    taille: "43 KB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Gabon_-courbe_Janv_16-1-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de février 2016",
    taille: "42 KB",
    pays: " Gabon",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CMR_courbe_Février_16-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de février 2016",
    taille: "42 KB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CMR_courbe_Janv_16-1-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de janvier 2016",
    taille: "42 KB",
    pays: " Cameroun",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_des_taux_gab_122015-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de décembre 2015",
    taille: "43 KB",
    pays: " Gabon",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_des_taux_gab_112015-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de novembre 2015",
    taille: "43 KB",
    pays: " Gabon",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_des_taux_cmr_122015-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de décembre 2015",
    taille: "43 KB",
    pays: " Cameroun",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbe_des_taux_cmr_112015-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de novembre 2015",
    taille: "41 KB",
    pays: " Cameroun",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT_CMR_Oct2015-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois d'octobre 2015",
    taille: "337 KB",
    pays: " Gabon",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT_Gabon_Sept2015-1.pdf", title:"Courbe des taux de rendement des titres publics gabonais pour le mois de septembre 2015",
    taille: "360 KB",
    pays: " Gabon",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT_Gabon_Octo2015-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois d'octobre 2015",
    taille: "349 KB",
    pays: " Cameroun",
    annee: " 2015",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT_CMR_Sept2015-1.pdf", title:"Courbe des taux de rendement des titres publics camerounais pour le mois de septembre 2015",
    taille: "337 KB",
    pays: " Cameroun",
    annee: " 2015",
  },
  
];
